import script from "./Joinus.vue?vue&type=script&setup=true&lang=js"
export * from "./Joinus.vue?vue&type=script&setup=true&lang=js"

import "./Joinus.vue?vue&type=style&index=0&id=386c9eb8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-386c9eb8"]])

export default __exports__